module.exports = __webpack_public_path__ + "img/logo.421de229.jpg";